import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CappTeamMsg, InterfaceService} from '../../services/interface.service';
import {AdminService} from '../../services/admin.service';
import {RoeTemplateComponent} from '../roe-template/roe-template.component';

@Component({
  selector: 'app-roe-survey',
  templateUrl: './roe-survey.component.html',
  styleUrls: ['./roe-survey.component.css']
})
export class RoeSurveyComponent  extends RoeTemplateComponent implements OnInit {
  @Input()
  i: number;

  @Output()
  delete = new EventEmitter();

  colone = '25%';
  coltwo = '75%';

  primarycolor: string;
  secondarycolor: string;

  constructor(public is: InterfaceService,
              public admin: AdminService) {
    super(admin, is);
    this.primarycolor = this.admin.getPrimary();
    this.secondarycolor = this.admin.getSecondary();
  }

  ngOnInit() {
    super.ngOnInit();
    const x = Math.round(9000 / this.admin.appwidth);
    this.colone = `${x}%`;
    this.coltwo = `${100 - x}%`;

  }

}
